import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/ad54991f71927b64ff80883b6b05b827.jpg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-navy-800/90 via-navy-800/85 to-navy-800/90"></div>
      </div>

      <div className="relative text-center px-6 max-w-4xl mx-auto">
        <h2 className="font-montserrat font-bold text-6xl lg:text-7xl text-white mb-6 tracking-wide uppercase">
          READY TO OPTIMIZE YOUR TAXES?
        </h2>
        <p className="text-white text-xl font-sans mb-3">Schedule your free consultation today</p>
        <p className="text-white/80 text-lg font-sans mb-10">Expert guidance for your financial future</p>
        
        <Link
          to="/contact"
          className="inline-flex items-center gap-4 bg-black text-white px-10 py-5 rounded-full font-sans font-bold text-lg hover:bg-orange-500 transition-all shadow-2xl whitespace-nowrap cursor-pointer group"
        >
          <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-full group-hover:bg-white group-hover:text-orange-500 transition-colors">
            <i className="ri-calendar-line text-xl"></i>
          </div>
          BOOK APPOINTMENT
          <i className="ri-arrow-right-line text-xl"></i>
        </Link>
      </div>
    </section>
  );
};

export default CTASection;
